/**
 * UI de operação (equipe, WhatsApp, comprar créditos, monitor).
 * PT / EN / ES — merged em messages.js
 */

const ptBR = {
  /* —— Equipe —— */
  'team.adminTeam': 'Equipe',
  'team.myTeam': 'Minha equipe',
  'team.subAdmin':
    'Atendentes do painel, comissões e o que cada um pode ver no monitor e no financeiro.',
  'team.subReseller': 'Atendentes vinculados à sua revenda, comissões e política local.',
  'team.newAttendant': 'Novo atendente',
  'team.editAttendant': 'Editar atendente',
  'team.newAttendantReseller': 'Novo atendente da sua equipe',
  'team.kpiAttendants': 'Atendentes',
  'team.kpiActive': 'Ativos',
  'team.kpiInactive': 'Inativos',
  'team.kpiAvgCommission': 'Comissão média',
  'team.policyTitle': 'Política para atendentes',
  'team.loadingPolicy': 'Carregando política…',
  'team.savePolicy': 'Salvar política',
  'team.members': 'Membros',
  'team.countOnTeam': '{n} na equipe',
  'team.countFiltered': '{filtered} de {total} filtrados',
  'team.searchPlaceholder': 'Buscar nome, e-mail…',
  'team.emptyTitle': 'Monte a sua equipe',
  'team.emptySub':
    'Crie o primeiro atendente para operar o painel, receber comissões e aparecer no ranking.',
  'team.noResults': 'Nenhum resultado',
  'team.noResultsSub': 'Ajuste a busca ou o filtro de status.',
  'team.active': 'Ativo',
  'team.inactive': 'Inativo',
  'team.commission': 'Comissão',
  'team.accessOn': 'Acesso ativo',
  'team.accessOff': 'Sem acesso',
  'team.minAccess': 'Acesso mínimo',
  'team.profile': 'Perfil',
  'team.create': 'Criar',
  'team.edit': 'Editar',
  'team.delete': 'Excluir',

  /* —— WhatsApp / conexões —— */
  'wa.serviceOnline': 'Serviço online',
  'wa.serviceOnlineSession': 'Serviço online (sessão)',
  'wa.serviceOffline': 'Serviço offline',
  'wa.kpiInstances': 'Instâncias',
  'wa.kpiConnected': 'Conectadas',
  'wa.kpiOffline': 'Offline',
  'wa.kpiSyncing': 'Sincronizando',
  'wa.connectionsTitle': 'Conexões Evolution',
  'wa.connectionsSub': 'Cada cartão é um número WhatsApp ligado ao CRM.',
  'wa.diagnostic': 'Diagnóstico',
  'wa.repairWebhooks': 'Reparar webhooks',
  'wa.loading': 'Carregando conexões…',
  'wa.newConnection': 'Nova conexão',
  'wa.newConnectionSub': 'Adicione um número WhatsApp via QR Evolution',
  'wa.configTitle': 'Configurar WhatsApp',
  'wa.nameLabel': 'Nome identificador',
  'wa.namePlaceholder': 'Ex: Comercial',
  'wa.motor': 'Motor',
  'wa.motorQr': 'QR Code (Evolution)',
  'wa.addInstance': 'Adicionar instância',
  'wa.sessionActive': 'Sessão ativa',
  'wa.awaitingPair': 'Aguardando pareamento',
  'wa.sync': 'Sync',
  'wa.syncHistory': 'Sincronizar histórico',
  'wa.syncing': 'Sincronização em andamento…',
  'wa.scanQr': 'Escanear QR',
  'wa.emptyHint': 'Ainda não há números ligados. Use Nova conexão para começar.',
  'wa.qrTitle': 'Pareamento WhatsApp',
  'wa.qrDesc': 'Escaneie o QR no celular para sincronizar a instância',
  'wa.generatingQr': 'Gerando QR Code…',
  'wa.wakingMotor': 'Preparando conexão…',
  'wa.cancelPairing': 'Cancelar pareamento',
  'wa.connect': 'Conectar',
  'wa.disconnect': 'Desconectar',

  /* —— Comprar créditos —— */
  'buy.kpiPacks': 'Pacotes',
  'buy.kpiBalance': 'Seu saldo',
  'buy.kpiFrom': 'A partir de',
  'buy.kpiValidity': 'Validade',
  'buy.catalog': 'Catálogo',
  'buy.postpaidTitle': 'Modo crédito',
  'buy.postpaidSub': 'Compre créditos antecipadamente e use-os nas ativações da sua rede.',
  'buy.addBalance': 'Adicionar saldo',
  'buy.validityHint':
    'Créditos comprados valem por {n} dias após a confirmação do pagamento.',
  'buy.pixTitle': 'Pagamento PIX',
  'buy.pixSub': 'Escaneie o QR no app do banco ou copie o código "copia e cola" abaixo.',
  'buy.paid': 'pago',
  'buy.expired': 'expirado',
  'buy.preparingQr': 'A preparar o QR Code…',
  'buy.copyPaste': 'Código copia e cola (PIX)',
  'buy.copyCode': 'Copiar código PIX',
  'buy.confirmPay': 'Confirmar pagamento',
  'buy.newPix': 'Gerar novo PIX',
  'buy.loading': 'Carregando pacotes…',
  'buy.bestValue': 'Melhor custo',
  'buy.creditsN': '{n} créditos',
  'buy.daysN': '{n} dias',
  'buy.investment': 'Investimento',
  'buy.perCredit': '≈ {price} por crédito',
  'buy.buyNow': 'Comprar agora',
  'buy.emptyTitle': 'Nenhum pacote disponível',
  'buy.emptyReseller':
    'Peça ao administrador para configurar os pacotes em Servidor → Pacotes, ou ao seu revendedor master se for sub-revenda.',
  'buy.checkoutTitle': 'Confirmar compra',
  'buy.checkoutSub': 'Revise o pacote e gere o PIX para liberar os créditos.',
  'buy.packFallback': 'Pacote',
  'buy.commissionOptional': 'Comissão (opcional)',
  'buy.noAttendant': 'Nenhum atendente',
  'buy.none': 'Nenhum',
  'buy.docLabel': 'CPF / CNPJ do pagador',
  'buy.optional': 'Opcional',
  'buy.generatePix': 'Gerar PIX',
  'buy.generatingPix': 'A gerar PIX…',

  /* —— Monitor da equipe —— */
  'attmon.live': 'Ao vivo',
  'attmon.last8h': 'Últimas 8 h',
  'attmon.last24h': 'Últimas 24 h',
  'attmon.last3d': 'Últimos 3 dias',
  'attmon.lastWeek': 'Última semana',
  'attmon.docsPending': 'Atestados / documentos pendentes ({n})',
  'attmon.openFile': 'Abrir arquivo',
  'attmon.approve': 'Aprovar',
  'attmon.reject': 'Rejeitar',
  'attmon.kpiOnline': 'Online agora',
  'attmon.kpiAvailable': 'Disponíveis',
  'attmon.kpiPause': 'Em pausa',
  'attmon.kpiOff': 'Fora',
  'attmon.kpiMsgs': 'Mensagens',
  'attmon.kpiScore': 'Score total',
  'attmon.activityTitle': 'Atividade no período',
  'attmon.statusDistTitle': 'Distribuição de status',
  'attmon.rankingTitle': 'Ranking de score',
  'attmon.searchPlaceholder': 'Buscar por nome, e-mail ou WhatsApp…',
  'attmon.filterAll': 'Todos',
  'attmon.filterOnline': 'Online',
  'attmon.filterAvailable': 'Disponíveis',
  'attmon.filterPause': 'Pausa',
  'attmon.filterOff': 'Fora',
  'attmon.emptyFilter': 'Nenhum atendente neste filtro.',
  'attmon.emptyChart': 'Sem atendentes do painel.',
  'attmon.loading': 'Carregando…',
  'attmon.activeNow': 'Ativo agora',
  'attmon.noSends': 'Sem envios (15 min)',
  'attmon.metricShift': 'Ponto / turno',
  'attmon.metricLastLogin': 'Último login',
  'attmon.metricLastActivity': 'Última atividade',
  'attmon.metricFirstReply': '1.ª resposta',
  'attmon.metricContacts': 'Contatos',
  'attmon.metricMsgs': 'Mensagens',
  'attmon.metricConvos': 'Conversas',
  'attmon.metricSales': 'Vendas pagas',
  'attmon.chartMsgs': 'Mensagens',
  'attmon.chartConvos': 'Conversas',
  'attmon.chartSales': 'Vendas',
  'attmon.chartScore': 'Score',
  'attmon.pieAvailable': 'Disponível',
  'attmon.piePause': 'Em pausa',
  'attmon.pieOff': 'Fora',
  'attmon.pieSick': 'Atestado',
  'attmon.pieActive': 'Ativo',
};

const en = {
  'team.adminTeam': 'Team',
  'team.myTeam': 'My team',
  'team.subAdmin':
    'Panel attendants, commissions, and what each can see in sales monitor and finance.',
  'team.subReseller': 'Attendants linked to your reseller account, commissions, and local policy.',
  'team.newAttendant': 'New attendant',
  'team.editAttendant': 'Edit attendant',
  'team.newAttendantReseller': 'New attendant for your team',
  'team.kpiAttendants': 'Attendants',
  'team.kpiActive': 'Active',
  'team.kpiInactive': 'Inactive',
  'team.kpiAvgCommission': 'Avg. commission',
  'team.policyTitle': 'Attendant policy',
  'team.loadingPolicy': 'Loading policy…',
  'team.savePolicy': 'Save policy',
  'team.members': 'Members',
  'team.countOnTeam': '{n} on the team',
  'team.countFiltered': '{filtered} of {total} filtered',
  'team.searchPlaceholder': 'Search name, email…',
  'team.emptyTitle': 'Build your team',
  'team.emptySub':
    'Create the first attendant to run the panel, earn commissions, and appear in rankings.',
  'team.noResults': 'No results',
  'team.noResultsSub': 'Adjust the search or status filter.',
  'team.active': 'Active',
  'team.inactive': 'Inactive',
  'team.commission': 'Commission',
  'team.accessOn': 'Access on',
  'team.accessOff': 'No access',
  'team.minAccess': 'Minimum access',
  'team.profile': 'Profile',
  'team.create': 'Create',
  'team.edit': 'Edit',
  'team.delete': 'Delete',

  'wa.serviceOnline': 'Service online',
  'wa.serviceOnlineSession': 'Service online (session)',
  'wa.serviceOffline': 'Service offline',
  'wa.kpiInstances': 'Instances',
  'wa.kpiConnected': 'Connected',
  'wa.kpiOffline': 'Offline',
  'wa.kpiSyncing': 'Syncing',
  'wa.connectionsTitle': 'Evolution connections',
  'wa.connectionsSub': 'Each card is a WhatsApp number linked to the CRM.',
  'wa.diagnostic': 'Diagnostics',
  'wa.repairWebhooks': 'Repair webhooks',
  'wa.loading': 'Loading connections…',
  'wa.newConnection': 'New connection',
  'wa.newConnectionSub': 'Add a WhatsApp number via Evolution QR',
  'wa.configTitle': 'Configure WhatsApp',
  'wa.nameLabel': 'Display name',
  'wa.namePlaceholder': 'e.g. Sales',
  'wa.motor': 'Engine',
  'wa.motorQr': 'QR Code (Evolution)',
  'wa.addInstance': 'Add instance',
  'wa.sessionActive': 'Active session',
  'wa.awaitingPair': 'Waiting to pair',
  'wa.sync': 'Sync',
  'wa.syncHistory': 'Sync history',
  'wa.syncing': 'Sync in progress…',
  'wa.scanQr': 'Scan QR',
  'wa.emptyHint': 'No numbers linked yet. Use New connection to get started.',
  'wa.qrTitle': 'WhatsApp pairing',
  'wa.qrDesc': 'Scan the QR on your phone to sync this instance',
  'wa.generatingQr': 'Generating QR Code...',
  'wa.wakingMotor': 'Waking engine...',
  'wa.cancelPairing': 'Cancel pairing',
  'wa.connect': 'Connect',
  'wa.disconnect': 'Disconnect',

  'buy.kpiPacks': 'Packages',
  'buy.kpiBalance': 'Your balance',
  'buy.kpiFrom': 'From',
  'buy.kpiValidity': 'Validity',
  'buy.catalog': 'Catalog',
  'buy.postpaidTitle': 'Credit mode',
  'buy.postpaidSub': 'Buy credits in advance and use them for your network activations.',
  'buy.addBalance': 'Add balance',
  'buy.validityHint':
    'Purchased credits are valid for {n} days after payment confirmation.',
  'buy.pixTitle': 'PIX payment',
  'buy.pixSub': 'Scan the QR in your banking app or copy the paste code below.',
  'buy.paid': 'paid',
  'buy.expired': 'expired',
  'buy.preparingQr': 'Preparing QR Code…',
  'buy.copyPaste': 'PIX copy-and-paste code',
  'buy.copyCode': 'Copy PIX code',
  'buy.confirmPay': 'Confirm payment',
  'buy.newPix': 'Generate new PIX',
  'buy.loading': 'Loading packages…',
  'buy.bestValue': 'Best value',
  'buy.creditsN': '{n} credits',
  'buy.daysN': '{n} days',
  'buy.investment': 'Price',
  'buy.perCredit': '≈ {price} per credit',
  'buy.buyNow': 'Buy now',
  'buy.emptyTitle': 'No packages available',
  'buy.emptyReseller':
    'Ask an admin to set up packages under Servidor → Packages, or your master reseller if you are a sub-reseller.',
  'buy.checkoutTitle': 'Confirm purchase',
  'buy.checkoutSub': 'Review the package and generate PIX to release credits.',
  'buy.packFallback': 'Package',
  'buy.commissionOptional': 'Commission (optional)',
  'buy.noAttendant': 'No attendant',
  'buy.none': 'None',
  'buy.docLabel': 'Payer CPF / CNPJ',
  'buy.optional': 'Optional',
  'buy.generatePix': 'Generate PIX',
  'buy.generatingPix': 'Generating PIX…',

  'attmon.live': 'Live',
  'attmon.last8h': 'Last 8 h',
  'attmon.last24h': 'Last 24 h',
  'attmon.last3d': 'Last 3 days',
  'attmon.lastWeek': 'Last week',
  'attmon.docsPending': 'Pending sick notes / documents ({n})',
  'attmon.openFile': 'Open file',
  'attmon.approve': 'Approve',
  'attmon.reject': 'Reject',
  'attmon.kpiOnline': 'Online now',
  'attmon.kpiAvailable': 'Available',
  'attmon.kpiPause': 'On break',
  'attmon.kpiOff': 'Off duty',
  'attmon.kpiMsgs': 'Messages',
  'attmon.kpiScore': 'Total score',
  'attmon.activityTitle': 'Activity in period',
  'attmon.statusDistTitle': 'Status distribution',
  'attmon.rankingTitle': 'Score ranking',
  'attmon.searchPlaceholder': 'Search by name, email or WhatsApp…',
  'attmon.filterAll': 'All',
  'attmon.filterOnline': 'Online',
  'attmon.filterAvailable': 'Available',
  'attmon.filterPause': 'Break',
  'attmon.filterOff': 'Off',
  'attmon.emptyFilter': 'No attendants in this filter.',
  'attmon.emptyChart': 'No panel attendants.',
  'attmon.loading': 'Loading…',
  'attmon.activeNow': 'Active now',
  'attmon.noSends': 'No sends (15 min)',
  'attmon.metricShift': 'Clock / shift',
  'attmon.metricLastLogin': 'Last login',
  'attmon.metricLastActivity': 'Last activity',
  'attmon.metricFirstReply': '1st reply',
  'attmon.metricContacts': 'Contacts',
  'attmon.metricMsgs': 'Messages',
  'attmon.metricConvos': 'Conversations',
  'attmon.metricSales': 'Paid sales',
  'attmon.chartMsgs': 'Messages',
  'attmon.chartConvos': 'Conversations',
  'attmon.chartSales': 'Sales',
  'attmon.chartScore': 'Score',
  'attmon.pieAvailable': 'Available',
  'attmon.piePause': 'On break',
  'attmon.pieOff': 'Off',
  'attmon.pieSick': 'Sick leave',
  'attmon.pieActive': 'Active',
};

const es = {
  'team.adminTeam': 'Equipo',
  'team.myTeam': 'Mi equipo',
  'team.subAdmin':
    'Agentes del panel, comisiones y lo que cada uno puede ver en el monitor y finanzas.',
  'team.subReseller': 'Agentes vinculados a tu reventa, comisiones y política local.',
  'team.newAttendant': 'Nuevo agente',
  'team.editAttendant': 'Editar agente',
  'team.newAttendantReseller': 'Nuevo agente de tu equipo',
  'team.kpiAttendants': 'Agentes',
  'team.kpiActive': 'Activos',
  'team.kpiInactive': 'Inactivos',
  'team.kpiAvgCommission': 'Comisión media',
  'team.policyTitle': 'Política para agentes',
  'team.loadingPolicy': 'Cargando política…',
  'team.savePolicy': 'Guardar política',
  'team.members': 'Miembros',
  'team.countOnTeam': '{n} en el equipo',
  'team.countFiltered': '{filtered} de {total} filtrados',
  'team.searchPlaceholder': 'Buscar nombre, email…',
  'team.emptyTitle': 'Arma tu equipo',
  'team.emptySub':
    'Crea el primer agente para operar el panel, recibir comisiones y aparecer en el ranking.',
  'team.noResults': 'Sin resultados',
  'team.noResultsSub': 'Ajusta la búsqueda o el filtro de estado.',
  'team.active': 'Activo',
  'team.inactive': 'Inactivo',
  'team.commission': 'Comisión',
  'team.accessOn': 'Acceso activo',
  'team.accessOff': 'Sin acceso',
  'team.minAccess': 'Acceso mínimo',
  'team.profile': 'Perfil',
  'team.create': 'Crear',
  'team.edit': 'Editar',
  'team.delete': 'Eliminar',

  'wa.serviceOnline': 'Servicio en línea',
  'wa.serviceOnlineSession': 'Servicio en línea (sesión)',
  'wa.serviceOffline': 'Servicio desconectado',
  'wa.kpiInstances': 'Instancias',
  'wa.kpiConnected': 'Conectadas',
  'wa.kpiOffline': 'Offline',
  'wa.kpiSyncing': 'Sincronizando',
  'wa.connectionsTitle': 'Conexiones Evolution',
  'wa.connectionsSub': 'Cada tarjeta es un número de WhatsApp ligado al CRM.',
  'wa.diagnostic': 'Diagnóstico',
  'wa.repairWebhooks': 'Reparar webhooks',
  'wa.loading': 'Cargando conexiones…',
  'wa.newConnection': 'Nueva conexión',
  'wa.newConnectionSub': 'Añade un número WhatsApp vía QR Evolution',
  'wa.configTitle': 'Configurar WhatsApp',
  'wa.nameLabel': 'Nombre identificador',
  'wa.namePlaceholder': 'Ej: Comercial',
  'wa.motor': 'Motor',
  'wa.motorQr': 'QR Code (Evolution)',
  'wa.addInstance': 'Añadir instancia',
  'wa.sessionActive': 'Sesión activa',
  'wa.awaitingPair': 'Esperando emparejamiento',
  'wa.sync': 'Sync',
  'wa.syncHistory': 'Sincronizar historial',
  'wa.syncing': 'Sincronización en curso…',
  'wa.scanQr': 'Escanear QR',
  'wa.emptyHint': 'Aún no hay números vinculados. Usa Nueva conexión para empezar.',
  'wa.qrTitle': 'Emparejamiento WhatsApp',
  'wa.qrDesc': 'Escanea el QR en el móvil para sincronizar la instancia',
  'wa.generatingQr': 'Generando QR Code...',
  'wa.wakingMotor': 'Despertando motor...',
  'wa.cancelPairing': 'Cancelar emparejamiento',
  'wa.connect': 'Conectar',
  'wa.disconnect': 'Desconectar',

  'buy.kpiPacks': 'Paquetes',
  'buy.kpiBalance': 'Tu saldo',
  'buy.kpiFrom': 'Desde',
  'buy.kpiValidity': 'Validez',
  'buy.catalog': 'Catálogo',
  'buy.postpaidTitle': 'Modo crédito',
  'buy.postpaidSub': 'Compre créditos por adelantado y úselos en las activaciones de su red.',
  'buy.addBalance': 'Añadir saldo',
  'buy.validityHint':
    'Los créditos comprados valen {n} días tras la confirmación del pago.',
  'buy.pixTitle': 'Pago PIX',
  'buy.pixSub': 'Escanea el QR en la app del banco o copia el código abajo.',
  'buy.paid': 'pagado',
  'buy.expired': 'expirado',
  'buy.preparingQr': 'Preparando el QR Code…',
  'buy.copyPaste': 'Código copia y pega (PIX)',
  'buy.copyCode': 'Copiar código PIX',
  'buy.confirmPay': 'Confirmar pago',
  'buy.newPix': 'Generar nuevo PIX',
  'buy.loading': 'Cargando paquetes…',
  'buy.bestValue': 'Mejor valor',
  'buy.creditsN': '{n} créditos',
  'buy.daysN': '{n} días',
  'buy.investment': 'Inversión',
  'buy.perCredit': '≈ {price} por crédito',
  'buy.buyNow': 'Comprar ahora',
  'buy.emptyTitle': 'Ningún paquete disponible',
  'buy.emptyReseller':
    'Pide al administrador que configure los paquetes en Servidor → Paquetes, o a tu revendedor master si eres sub-reventa.',
  'buy.checkoutTitle': 'Confirmar compra',
  'buy.checkoutSub': 'Revisa el paquete y genera el PIX para liberar los créditos.',
  'buy.packFallback': 'Paquete',
  'buy.commissionOptional': 'Comisión (opcional)',
  'buy.noAttendant': 'Ningún agente',
  'buy.none': 'Ninguno',
  'buy.docLabel': 'CPF / CNPJ del pagador',
  'buy.optional': 'Opcional',
  'buy.generatePix': 'Generar PIX',
  'buy.generatingPix': 'Generando PIX…',

  'attmon.live': 'En vivo',
  'attmon.last8h': 'Últimas 8 h',
  'attmon.last24h': 'Últimas 24 h',
  'attmon.last3d': 'Últimos 3 días',
  'attmon.lastWeek': 'Última semana',
  'attmon.docsPending': 'Bajas / documentos pendientes ({n})',
  'attmon.openFile': 'Abrir archivo',
  'attmon.approve': 'Aprobar',
  'attmon.reject': 'Rechazar',
  'attmon.kpiOnline': 'Online ahora',
  'attmon.kpiAvailable': 'Disponibles',
  'attmon.kpiPause': 'En pausa',
  'attmon.kpiOff': 'Fuera',
  'attmon.kpiMsgs': 'Mensajes',
  'attmon.kpiScore': 'Score total',
  'attmon.activityTitle': 'Actividad en el período',
  'attmon.statusDistTitle': 'Distribución de estado',
  'attmon.rankingTitle': 'Ranking de score',
  'attmon.searchPlaceholder': 'Buscar por nombre, email o WhatsApp…',
  'attmon.filterAll': 'Todos',
  'attmon.filterOnline': 'Online',
  'attmon.filterAvailable': 'Disponibles',
  'attmon.filterPause': 'Pausa',
  'attmon.filterOff': 'Fuera',
  'attmon.emptyFilter': 'Ningún agente en este filtro.',
  'attmon.emptyChart': 'Sin agentes del panel.',
  'attmon.loading': 'Cargando…',
  'attmon.activeNow': 'Activo ahora',
  'attmon.noSends': 'Sin envíos (15 min)',
  'attmon.metricShift': 'Fichaje / turno',
  'attmon.metricLastLogin': 'Último acceso',
  'attmon.metricLastActivity': 'Última actividad',
  'attmon.metricFirstReply': '1.ª respuesta',
  'attmon.metricContacts': 'Contactos',
  'attmon.metricMsgs': 'Mensajes',
  'attmon.metricConvos': 'Conversaciones',
  'attmon.metricSales': 'Ventas pagadas',
  'attmon.chartMsgs': 'Mensajes',
  'attmon.chartConvos': 'Conversaciones',
  'attmon.chartSales': 'Ventas',
  'attmon.chartScore': 'Score',
  'attmon.pieAvailable': 'Disponible',
  'attmon.piePause': 'En pausa',
  'attmon.pieOff': 'Fuera',
  'attmon.pieSick': 'Baja médica',
  'attmon.pieActive': 'Activo',
};

export const OPS_UI_MESSAGES = {
  'pt-BR': ptBR,
  en,
  es,
};
